module.exports = __webpack_public_path__ + "img/Scarpa_ALTA_GRIGIO_SX.474ead80.png";